<div class="flex flex-col flex-auto w-full ">
  <div class="p-4 bg-card shadow rounded-lg rounded-md rounded-sm rounded-xl my-4">
  <div class="ttl">Help videos</div>
  <mat-divider></mat-divider>
  <div class="container my-4">
    <mat-form-field style="    width: 60% !important;
    margin: 0px auto;
    display: block;">
      <input matInput placeholder="input search text" [(ngModel)]="filterTerm">
      <button matSuffix mat-icon-button aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div class="text-left" *ngFor="let m of vdeosList">
    <span class="text-lg font-semibold">{{m.vdo_grp_nm}}</span>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
      <div class="col-span-1" *ngFor="let v of m.videos">
        <mat-card class="h-full">
          <mat-card-content>
            <a class="block mb-2">
              <img [src]="v.thmbl_imge_url_tx" class="w-full h-32 object-cover rounded">
            </a>
            <iframe [src]="v.safeURL" frameborder="0" 
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="w-full h-32 mb-2"></iframe>
            <p class="font-medium">{{v.vdo_nm}}</p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
</div>
